<script lang="ts">
  // Ein gehaltener Tab (EditorArea.svelte, „Gehaltene Tabs"): sagt der
  // Seite darin, ob sie gerade vorn steht (seiteVorn in page-route.ts).
  // Verdeckte Seiten bleiben gebaut; was nur vorn laufen soll (schneller
  // Takt, Tastenkürzel), fragt hier nach.
  import type { Snippet } from "svelte";
  import { setSeiteVorn } from "./page-route";

  let { vorn, children }: { vorn: boolean; children: Snippet } = $props();
  setSeiteVorn(() => vorn);
</script>

{@render children()}
